var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGScholar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "2.5rem",
    height: "2.5rem",
    viewBox: "0 0 36.801 36.801",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 0A18.4 18.4 0 000 18.4a18.4 18.4 0 0018.4 18.401 18.4 18.4 0 0018.4-18.4A18.4 18.4 0 0018.4 0zm-.884 4.585l13.896 9.332 1.328 1.24v10.222h-2.816l-.14-10.369-12.268 8.238L3.62 13.917zm7.964 16.656l1.63 2.296-8.89 6.26-8.869-6.26 1.63-2.295 7.227 5.193z",
    paintOrder: "fill markers stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGScholar);
export default __webpack_public_path__ + "static/media/g-scholar.fb077ea79e8f6dc6d629ee6d8c8b1098.svg";
export { ForwardRef as ReactComponent };